import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApi } from 'Data/Obras.api';

export const useQueryObra = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [OBRA_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const response = await ObrasApi.list();
      return response.data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
